import angular from 'angular';
import template from './transfer_card.html.slim';
import controller from './transfer_card_controller';

const directive = {
  restrict: 'E',
  controller,
  controllerAs: 'ctrl',
  bindToController: true,
  replace: true,
  templateUrl: template,
  scope: {
    'transfers': '=?',
    'transfer': '=',
    'accounts': '=',
    'categories': '=',
    'request': '&',
    'config': '=?'
  }
}

angular.module('wbComponents').directive('wbTransferCard', () => directive);
